const COMMUNITY_IMAGE_BY_KEY: Readonly<Record<string, string>> = {
  pcos: '/community-images/community-pcos-512.webp',
  diabetes: '/community-images/community-diabetes-512.webp',
  'mental-health': '/community-images/community-mental-wellness-512.webp',
  'mental-wellness': '/community-images/community-mental-wellness-512.webp',
  thyroid: '/community-images/community-thyroid-512.webp',
  'skin-acne': '/community-images/community-skin-acne-512.webp'
};

const COMMUNITY_BADGE_BY_KEY: Readonly<Record<string, string>> = {
  pcos: '/assets/icons/communities/pcos.svg',
  diabetes: '/assets/icons/communities/diabetes.svg',
  'mental-health': '/assets/icons/communities/mental-health.svg',
  'mental-wellness': '/assets/icons/communities/mental-health.svg',
  thyroid: '/assets/icons/communities/thyroid.svg',
  'skin-acne': '/assets/icons/communities/skin-acne.svg'
};

function normalizeCommunityKey(community: string | null | undefined): string {
  return (community ?? '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

export function resolveCommunityImage(community: string | null | undefined): string | null {
  return COMMUNITY_IMAGE_BY_KEY[normalizeCommunityKey(community)] ?? null;
}

export function resolveCommunityBadge(community: string | null | undefined): string | null {
  return COMMUNITY_BADGE_BY_KEY[normalizeCommunityKey(community)] ?? null;
}
